'use client'

import React, { PropsWithChildren } from 'react'
import { SideBar } from './SideBar'

export const Layout = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex h-[100svh] w-full justify-center overflow-x-hidden bg-gray-200 fold:bg-white">
      <div id="root-layout" className="relative w-full overflow-y-hidden overflow-x-hidden bg-white pc:w-[512px]">
        <SideBar />
        <div className="w-full h-full overflow-y-scroll overflow-x-hidden relative pc:scrollbar-hide">{children}</div>
      </div>
    </div>
  )
}
